import * as React from 'react'
import { convertMinutes } from './utils'
import './DataTable.scss';

function getTotalRow(data: any) {
  const totalRow: any = ["Total"]
  data.slice(1).forEach((row: any) => {
    row.forEach((value: string, index: number) => {
      if (index > 0) {
        totalRow[index] ?
          totalRow[index] += parseFloat(value) :
          totalRow[index] = parseFloat(value)
      }
    })
  })
  totalRow.forEach((value: number, index: number) => {
    if (/Min|Max/.test(data[0][index])) {
      totalRow[index] = '' //Math.round(totalRow[index] / (data.length - 1) * 100) / 100
    } else if (index > 0) {
      totalRow[index] = Math.round(totalRow[index] * 100) / 100
    }
  })
  return totalRow
}

function getAverageRow(data: any) {
  const totalRow: any = ["Average"]
  data.slice(1).forEach((row: any) => {
    row.forEach((value: string, index: number) => {
      if (index > 0) {
        totalRow[index] ?
          totalRow[index] += parseFloat(value) :
          totalRow[index] = parseFloat(value)
      }
    })
  })
  totalRow.forEach((value: number, index: number) => {
    if (index > 0) {
      totalRow[index] = Math.round(totalRow[index] / (data.length - 1) * 100) / 100
    }
  })
  return totalRow
}


function formatColumn(data: any, column: any, index: number) {
  if (/Time/.test(data[0][index])) {
    return convertMinutes(parseInt(column, 10))
  }
  return column
}

export class DataTable extends React.Component<{data: any}> {
  render() {
    const {data} = this.props
    const totalRow = getTotalRow(data)
    const averageRow = getAverageRow(data)
    return <div className="table-container">
      <table>
        <thead>
          <tr>
            {data[0].map((d: string) => <th>{d}</th>)}
          </tr>
        </thead>
        <tbody>
          <tr className="total-row">
            {totalRow.map((d: any, index: number) => <td>{formatColumn(data, d, index)}</td>)}
          </tr>
          <tr className="total-row">
            {averageRow.map((d: any, index: number) => <td>{formatColumn(data, d, index)}</td>)}
          </tr>
          {data.slice(1).map((row: any) => <tr>
            {row.map((d: any, index: number) => <td>{formatColumn(data, d, index)}</td>)}
          </tr>)}
        </tbody>
      </table>
    </div>
  }
}